export const videoStatus = {
  DRAFT: "Rascunho",
  PUBLISHED: "Publicado",
  ARCHIVED: "Arquivado",
  TRANSCODING: "Transcodificando",
  FAILED: "Erro na transcodificação",
  EXPIRED: "Expirado",
  SCHEDULED: "Agendado",
};
export default videoStatus;